import { getDepartmentTree, getDepartmentUsers, roleList } from '@/views/approvalCenter/api'
import { cloneDeep } from 'lodash'

const state = {
  deptsMap: {}, // 部门集合
  departMentTree: [], // 部门tree列表
  rolesMap: {}, // 角色集合
  usersMap: {}, // 员工集合
  hasInfo: false // 已有数据重新不再请求
}

const mutations = {
  SET_DEPTS_MAP: (state, payload) => {
    state.deptsMap = payload
  },
  SET_ROLES_MAP: (state, payload) => {
    state.rolesMap = payload
  },
  SET_USERS_MAP: (state, payload) => {
    state.usersMap = payload
  },
  SET_DEPTS_TREE: (state, payload) => {
    state.departMentTree = payload
  },
  SET_INFO: (state) => {
    state.hasInfo = true
  }
}

const actions = {
  getDeptsMap({ commit }) {
    getDepartmentTree({}).then(res => {
      const { code, data } = res
      if (code === 200) {
        commit('SET_DEPTS_TREE', cloneDeep(data))
        const maps = {}
        const sort = (arr) => {
          arr.forEach((item) => {
            if (!maps[item.id]) {
              maps[item.id] = item
            }
            if (item.childList && item.childList.length > 0) {
              sort(item.childList)
            }
          })
        }
        sort(data)
        commit('SET_DEPTS_MAP', maps)
      }
    })
  },
  getRolesMap({ commit }) {
    roleList({}).then(res => {
      const { code, data } = res
      if (code === 200) {
        const maps = {}
        data.forEach((item) => {
          if (!maps[item.id]) {
            maps[item.id] = item
          }
        })
        commit('SET_ROLES_MAP', maps)
      }
    })
  },
  getUsersMap({ commit }) {
    getDepartmentUsers({}).then(res => {
      const { code, data } = res
      if (code === 200) {
        const maps = {}
        data.forEach((item) => {
          if (!maps[item.userId]) {
            item.accountName = item.name
            item.id = item.userId
            maps[item.userId] = item
          }
        })
        commit('SET_USERS_MAP', maps)
      }
    })
  },
  getOrgInfo({ dispatch, commit }) {
    dispatch('getUsersMap')
    dispatch('getRolesMap')
    dispatch('getDeptsMap')
    commit('SET_INFO')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
